export const amountWithTVA = (priceHT: number) => priceHT * (1 + 0.2);
